import type { FeatureRoute } from '../registry';
import { RolePermissionsPage } from './RolePermissionsPage';
import { TransactionsPage } from './TransactionsPage';

export const routes: FeatureRoute[] = [
  { path: 'customers/:id/transactions', element: <TransactionsPage kind="customers" /> },
  { path: 'suppliers/:id/transactions', element: <TransactionsPage kind="suppliers" /> },
  { path: 'accounts/:id/transactions', element: <TransactionsPage kind="accounts" /> },
  { path: 'roles/:id/permissions', element: <RolePermissionsPage /> }
];
